var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "async-config" }, [_c('iframe', { attrs: { "height": "800", "width": "100%", "src": _vm.configUrl, "frameborder": "0" } })]);
};
var staticRenderFns = [];

export { render, staticRenderFns };